import makeTypeCreator from '@/models/makeTypeCreator'

const namespace = 'messages'
const createType = makeTypeCreator(namespace)

export const RECEIVE_MESSAGE = createType('RECEIVE_MESSAGE')
export const FETCH_MESSAGES = createType('FETCH_MESSAGES')
export const MESSAGES_FETCHED = createType('MESSAGES_FETCHED')
export const SEND_MESSAGE = createType('SEND_MESSAGE')
export const PLAY_ACTION_AUDIO = createType('PLAY_ACTION_AUDIO')
export const REMOVE_MESSAGE = createType('REMOVE_MESSAGE')


